import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_ECRYPT_STORE_KEY;

export const encryptData = (data) => {
	try {
		const stringified = JSON.stringify(data);
		return CryptoJS.AES.encrypt(stringified, SECRET_KEY).toString();
	} catch (err) {
		console.error("Encryption error:", err);
		return null;
	}
};

export const decryptData = (ciphertext) => {
	try {
		if (!ciphertext) return null;
		const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
		const decrypted = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(decrypted);
	} catch (err) {
		console.error("Decryption error:", err);
		return null;
	}
};

export const secureStorage = {
	setSession: (key, value) => {
		const encrypted = encryptData(value);
		if (encrypted) {
			sessionStorage.setItem(key, encrypted);
		}
	},

	getSession: (key) => {
		const item = sessionStorage.getItem(key);
		return decryptData(item);
	},

	removeSession: (key) => {
		sessionStorage.removeItem(key);
	},

	setLocal: (key, value) => {
		const encrypted = encryptData(value);
		if (encrypted) {
			localStorage.setItem(key, encrypted);
		}
	},

	getLocal: (key) => {
		const item = localStorage.getItem(key);
		return decryptData(item);
	},

	removeLocal: (key) => {
		localStorage.removeItem(key);
	},
}
